module.exports = __webpack_public_path__ + "img/configure-benefits.05a849d0.svg";